import { createContext, useContext } from 'react';

export const AssociationContext = createContext({
    isTrial: null,
});

export const useAssociationContext = () => useContext(AssociationContext);

export default AssociationContext;